import script from "./Administrators.vue?vue&type=script&setup=true&lang=js"
export * from "./Administrators.vue?vue&type=script&setup=true&lang=js"

import "./Administrators.vue?vue&type=style&index=0&id=9a8e78d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a8e78d2"]])

export default __exports__